import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const fileTypesAdapter = getAdapter();

const fileTypesSlice = createSlice({
  name: 'fileTypes',
  initialState: fileTypesAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setFileTypes: (state, { payload: { fileTypes, source } }) => {
      fileTypesAdapter.setAll(state, fileTypes);
      state.source = source;
    },
  },
});

const selectors = fileTypesAdapter.getSelectors(({ fileTypes }) => fileTypes);

export const getFileTypes = (state) => selectors.selectAll(state);

export const {
  setFileTypes,
} = fileTypesSlice.actions;

export default fileTypesSlice.reducer;
